// extracted by mini-css-extract-plugin
export default {"main":"TextArea_main__UyXjT","title":"TextArea_title__E4Uey","content":"TextArea_content__X3xHo","helperFooter":"TextArea_helperFooter__aRkFv"};